<template>
  <v-layout row wrap>
    <v-flex xs12 sm10 md6 offset-md3 offset-sm1>
      <cliente-factura v-if="!hasfactura"></cliente-factura>
      <v-card v-else-if="hasfactura" class="factura" @keyup.ctrl.80 = "impresion">
        <v-card-title class="primary">
          <div style="display: flex; justify-content: space-between; margin: 0; width: 100%;" class="encabezado">
            <v-flex xs12  sm6>
              <b1 style="padding: 0" class="white--text"  name="cliente"> Cliente: {{cliente.nombre}}</b1>
            </v-flex>
            <v-flex xs12 v-if="cliente.nit"><b1 style="padding: 0" class="white--text" name="nit">Nit: {{cliente.nit}}</b1></v-flex>
            <v-flex xs12 v-if="!cliente.nit"><b1 style="padding: 0" class="white--text" name="nit">Nit: {{cliente.codigo}}</b1></v-flex>
            <v-flex xs12 class="ml-3" v-if="cliente.telefono && cliente.telefono.trim()"><b1 style="padding: 0" class="white--text" name="telefono">Teléfono: {{cliente.telefono}}</b1></v-flex>
            <v-flex xs12 class="ml-3" v-if="!cliente.telefono || !cliente.telefono.trim()"><b1 style="padding: 0" class="white--text" name="telefono">Teléfono: No tiene</b1></v-flex>
            <v-btn icon dark small @click.native="dialogEditarCliente = true" class="editar-cliente">
              <v-icon dark>edit</v-icon>
            </v-btn>
          </div>
          <div style="display: flex; justify-content: space-between; margin: 0; width: 100%;" class="factura__direccion">
            <v-flex xs12><b1 style="padding: 0" class="white--text">Direccion: {{cliente.direccion_completa}}</b1></v-flex>
          </div>
          <div class="factura__date">
            <v-flex xs12 >
              <b1 style="padding: 0" class="white--text"> Fecha: {{fecha}}</b1>
            </v-flex>
            <v-flex xs12 >
              <b1 style="padding: 0" class="white--text"> Hora: {{hora}}</b1>
            </v-flex>
            <v-flex xs12 >
              <b1 style="padding: 0" class="white--text" v-if="factura.credito">CREDITO</b1>
              <b1 style="padding: 0" class="white--text" v-if="!factura.credito">CONTADO</b1>
            </v-flex>
          </div>
          <v-flex xs6 md3 class="pa-0 ma-0 credito">
            <v-checkbox v-model="factura.credito" label="Al credito" dark @change="cambiarcredito">
            </v-checkbox>
          </v-flex>
          <v-flex xs6 md5 class="pa-0 mr-2 credito"  v-if="vender_bodega==true || tipo==='admin'">
            <v-checkbox v-model="factura.bodega" label="Sacar de Bodega" dark @change="actualizarbodega">
            </v-checkbox>
          </v-flex>
          <!--
          <v-flex sm3 xs6 class="hidden-sm-and-down pa-0 ma-0">
            <v-checkbox v-model="escambio" label="cambiar producto" dark>
            </v-checkbox>
          </v-flex>
          !-->
          <v-flex sm3 xs6 class="pa-0 ma-0 credito">
            <v-checkbox v-model="factura.envio" label="Es envío" dark @change="cambiarenvio" v-if=" tipo==='admin'">
            </v-checkbox>
          </v-flex>
          <v-flex xs6 class="pa-0 ma-0 total"><h5 class="white--text">Total: Q.{{total}}</h5></v-flex>
          <div class="existencia">
            <h4 class="warning--text">Existencia: {{producto.existencia}}</h4>
            <h5 class="warning--text existencia__vencimiento">
              Vence: {{producto.fecha_vencimiento | formatFechaVencimiento}}
            </h5>
          </div>
           <v-flex>
           <v-btn fab dark small color="primary" v-on:click.native="dialog = true" v-if="haslineas && this.$store.getters.gettipo === 'admin' || this.$store.getters.gettipo === 'secretaria' || usuario === '1' || usuario === 'L2'" class="print">
              <v-icon dark>print</v-icon>
            </v-btn>
             <v-btn fab dark small  v-if="haslineas" class="print yellow darken-4" @click="guardarfactura">
              <v-icon dark>save</v-icon>
            </v-btn>
            <v-btn fab dark small color="primary" v-on:click.native="dialogbusqueda = true" @click="focusbusqueda()" class="print"  v-bind:disabled="validatefactura">
              <v-icon dark>search</v-icon>
            </v-btn>
             <v-btn fab dark small accent v-on:click.native="message = true">
              <v-icon dark>email</v-icon>
            </v-btn>
             <v-btn fab color="primary" small primary v-on:click.native="messagemotivo = true" v-if="!haslineas">
              <v-icon dark>live_help</v-icon>
            </v-btn>
             <v-btn fab  small  error v-if="validatefactura" @click="nuevafactura">
              <v-icon dark>add</v-icon>
            </v-btn>
        </v-flex>
        </v-card-title>
        <v-flex sm12>
            <v-alert  error value="false" v-if="error">
              {{message_error}}
            </v-alert>
          <v-alert  success value="false" v-if="success">
           {{message_success}}
          </v-alert>
          </v-flex>
        <v-layout class="buscador ma-0 pa-0" fluid wrap >
          <v-flex xs12 sm2 >
            <div class="input-group input-group--text-field input-group--single-line">
              <label></label>
              <div class="input-group__input">
                <input tabindex="0" label="cod.Producto" type="text"
                ref="search"
              @keyup.ctrl.80 = "impresion"
              @keyup.enter="searchproducto"
              v-model="barra"
                       placeholder="cod."
              v-bind:disabled="validatefactura"
                >
              </div>
              <div class="input-group__details">
                <div class="input-group__messages">

                </div>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 >
            <v-text-field
              singleLine
              label="precio"
              disabled
              v-model="precio"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              singleLine=""
              label="producto"
              disabled
              v-model="producto.producto"
            >
            </v-text-field>
          </v-flex>
          <v-flex  xs4 sm1>
            <v-text-field
              type="number"
              @change="checklista()"
              @keyup="checklista"
              @keyup.enter="guardarventa"
              singleLine
              label="cantidad"
              min="1"
              v-model="cantidad"
              ref="cantidad"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs4 sm2>
            <div class="select">
               <select v-model="presentacion"  @change="checklista">
                <option v-for="press in presentaciones" v-bind:value="press">
                  {{ press.presentacion }}
                </option>
            </select>
            </div>
          </v-flex>
          <v-flex xs4 sm2>
            <div class="select xs6">
               <select v-model="listado"  @change="checklista">
                <option v-for="lista in producto.listaprecios" v-bind:value="lista">
                  {{ lista.lista.nombre }}
                </option>
            </select>
            </div>
          </v-flex>
          <v-flex hidden-md-and-up class="justify-center" xs12 v-if="!grabando">
            <v-btn fab dark small class="print blue darken-4" @click="guardarventa">
              <v-icon dark>save</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card v-show="hasfactura" class="factura__detalle">

        <v-flex style="overflow-x: auto" class="tabla">
           <table class="table text-md-center">
             <tr>
               <th></th>
              <th v-for="header in headers"> {{header.text}}</th>
             </tr>
              <tbody>
                <tr v-for="linea in lineas">
                  <td>
                  <v-btn icon class="red--text text--darken-2" @click="eliminar(linea)" :disabled="eliminando">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  </td>
                  <td>{{linea.cantidad}}</td>
                  <td>{{linea.presentacion }}</td>
                  <td>{{linea.producto_name}}</td>
                  <td>{{linea.precio }}</td>
                  <td>{{linea.precio * linea.cantidad | currency('Q') }}</td>
                </tr>
                <tr class="factura__detalle__total">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Total</td>
                  <td>{{total}}</td>
                </tr>
              </tbody>
           </table>
        </v-flex>

      </v-card>
      <v-dialog v-model="dialog" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Datos Factura</div>
        </v-card-title>
        <v-card-text>
          <v-alert  error value="false" v-if="error">
           {{message_error}}
          </v-alert>
          <v-alert  success value="false" v-if="success">
           {{message_success}}
          </v-alert>
          <h6>Total: Q.{{total}}</h6>
          <v-text-field label="Efectivo" v-model="efectivo" autofocus='true' @keyup.enter="guardardatosfactura">
          </v-text-field>
          <h4 class="primary--text">Cambio: Q.{{cambio}}</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialog = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="guardardatosfactura">Imprimir</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="imprimirelectronica"> Electrónica</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogbusqueda" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Buscar Producto</div>
           <v-flex sm12>
             <v-text-field label="Nombre" v-model="nombreproducto" @keyup="searchproductos" autofocus ref="searchprodi">
          </v-text-field>
           </v-flex>
        </v-card-title>
        <v-card-text>
          <ul class="listadoproducto">

            <li v-for="product, key in this.productos"
                @click="searchproductodialog(product), dialogbusqueda=false, nombreproducto = ''"
                @keyup.enter="searchproductodialog(product), dialogbusqueda=false, nombreproducto = ''"
                v-bind:tabindex="0">
               {{product.producto}}
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:tabindex="-1" class="green--text darken-1" flat="flat" @click.native="dialogbusqueda = false" @click="resetbusqueda">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="message" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Escribir Observación</div>
           <v-flex sm12>
             <v-text-field label="comentario" v-model="factura.observaciones"
                           @keyup.enter="cambiarcomentario"
                           multi-line
             >
          </v-text-field>
           </v-flex>
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:tabindex="-1" class="green--text darken-1" flat="flat" @click.native="message = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="message = false" @click="cambiarcomentario">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="messagemotivo" lazy absolute persistent >
      <v-card>
        <v-card-title>
          <div class="headline">Motivo por el que no compro</div>
           <v-flex sm12>
             <div class="select">
               <label for="motivo">Motivo:  </label>
               <select v-model="factura.observacionesmotivo"  @change="cambiarcomentariomotivo" id="motivo">
                <option v-for="motivo in motivos" v-bind:value="motivo">
                  {{ motivo }}
                </option>
            </select>
            </div>
           </v-flex>
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:tabindex="-1" class="green--text darken-1" flat="flat" @click.native="messagemotivo = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="messagemotivo = false" @click="cambiarcomentariomotivo">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditarCliente" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Editar Cliente</div>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Nombre:" v-model="cliente.nombre" singleLine=""></v-text-field>
          <v-text-field label="Nit:" v-model="cliente.nit" singleLine=""></v-text-field>
          <v-text-field label="Teléfono:" v-model="cliente.telefono" type="tel" singleLine=""></v-text-field>
          <v-text-field label="Correo:" v-model="cliente.correo" type="email" singleLine=""></v-text-field>
          <v-text-field label="Dirección:" v-model="cliente.direccion" singleLine=""></v-text-field>
          <v-text-field label="Referencia:" v-model="cliente.referencia" singleLine=""></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialogEditarCliente = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialogEditarCliente = false" @click="guardarcliente">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <div class="enletras" style="width: 100%">
        <span>TOTAL EN LETRAS: {{numerosaletras}}</span>
      </div>
      <v-flex class="firmas">
        <v-flex sm6>Vendedor: {{factura.usuario.username}}</v-flex>
        <v-flex sm6>Cliente</v-flex>
      </v-flex>

    </v-flex>
  </v-layout>
</template>

<script>
  import Fcliente from './Fcliente.vue'
  import NumerosLetras from '../librerias/numerosaletras'
  export default {
    components: {'cliente-factura': Fcliente},
    created: function () {
      this.$store.commit('actualizarmessageactual', this.factura.observaciones)
      this.$refs.cantidad.focus()
    },
    mounted: function () {
      this.$refs.search.focus()
    },
    data () {
      return {
        cantidad: 1,
        iscredito: false,
        prueba: true,
        foco: false,
        nombreproducto: '',
        dialogbusqueda: false,
        dialogEditarCliente: false,
        escambio: false,
        efectivo: '',
        message: false,
        messagemotivo: false,
        motivos: ['Cerrado', 'Ausente', 'Compra Barato', 'Tiene Producto'],
        headers: [
          { text: 'Cantidad' },
          { text: ' Presentación' },
          { text: 'Descripción' },
          { text: 'Precio' },
          { text: 'Subtotal' }
        ]
      }
    },
    methods: {
      impresion () {
        this.dialog = true
      },
      searchproducto () {
        this.$store.dispatch('buscarproducto', {producto: this.producto.barra, bodega: this.factura.bodega})
        if (localStorage.getItem('usuario') === '1' || localStorage.getItem('usuario') === 'L2') {
          this.$refs.cantidad.focus()
        }
      },
      searchproductodialog (event) {
        this.$store.commit('actualizar_success', event.has_bonificacion && event.existencia > 0)
        this.$store.commit('actualizarmessage_success', 'Este producto tiene bonificación')
        if (event.barra) {
          this.$store.dispatch('buscarproducto', {producto: event.barra, bodega: this.factura.bodega})
        } else {
          this.$store.dispatch('buscarproducto', {producto: event.codigo, bodega: this.factura.bodega})
        }
        if (localStorage.getItem('usuario') === '1' || localStorage.getItem('usuario') === 'L2') {
          this.$refs.cantidad.focus()
        }
      },
      searchproductos () {
        this.$store.dispatch('buscarproductos', {producto: this.nombreproducto, bodega: this.factura.bodega})
      },
      checklista () {
        if (this.listado.lista.nombre.toLowerCase() !== 'l4' && this.listado.lista.nombre.toLowerCase() !== 'l5' && this.producto.listaprecios.length <= 2) {
          let listadoordenado = this.producto.listaprecios.sort((dato1, dato2) => {
            return dato1.minimo - dato2.minimo
          })
          let listas = []
          let lista = []
          listadoordenado.map((dato) => {
            if (dato.lista.nombre.toLowerCase() !== 'l4' &&
              dato.lista.nombre.toLowerCase() !== 'l5' && dato.minimo <=
              this.cantidad * (this.presentacion.unidades)) {
              listas.push(dato)
            }
          })
          if (listas.length > 0) {
            lista = listas.reverse()
            this.$store.commit('updateselect', lista[0])
          } else {
            listas = listadoordenado.map(dato => {
              if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5') {
                lista.push(dato)
              }
            })
            this.$store.commit('updateselect', lista[0])
          }
        }
      },
      redondear (cantidad) {
        let exponente = 100
        let prueba = cantidad.toFixed(2)
        let reciduo = parseInt((prueba * exponente).toFixed() % 5)
        if (reciduo !== 0) {
          return (parseInt((cantidad.toFixed(2) * exponente).toFixed()) + 5 - reciduo) / exponente
        } else {
          return (cantidad.toFixed(2) * exponente) / exponente
        }
      },
      guardarventa () {
        let precio = 0
        let cantidad = 0
        this.$store.commit('setguardando', true)
        if (this.escambio) {
          precio = 0
        } else {
          precio = this.precio
        }
        this.escambio = false
        if (this.cantidad < 0) {
          cantidad = this.cantidad * -1
        } else {
          cantidad = this.cantidad
        }
        if (this.$store.getters.lineasfactura.length <= 30 || localStorage.getItem('usuario') === '1' || localStorage.getItem('usuario') === 'L2') {
          this.$store.dispatch('insertarlinea', { producto: this.producto.id,
            factura: this.factura.id,
            precio: precio,
            cantidad: cantidad,
            presentacion: this.presentacion.presentacion,
            listaprecio: this.listado.id
          })
        }
        this.cantidad = 1
        this.$refs.search.focus()
      },
      nuevafactura () {
        let id = this.cliente.id
        this.$store.dispatch('crearfactura2', id)
        this.cantidad = 1
        this.$refs.search.focus()
      },

      cambiarcredito () {
        this.$store.dispatch('actualizartipofactura', {factura: this.factura})
      },
      cambiarenvio () {
        this.$store.dispatch('actualizarenvio', {factura: this.factura})
      },
      cambiarcomentario () {
        this.$store.dispatch('actualizarcomentario', {factura: this.factura})
      },
      imprimirelectronica () {
        if (this.lineas.length === 0) {
          this.$store.commit('actualizarerror', true)
          this.$store.commit('actualizarmessage_error', 'por favor ingrese productos')
        } else {
          this.$store.dispatch('imprimirfacturaelectronica', {factura: this.factura})
        }
      },
      cambiarcomentariomotivo () {
        this.$store.dispatch('actualizarcomentario', {factura: this.factura})
      },
      async eliminar (linea) {
        let a = confirm('desea eliminar ' + linea.producto_name)
        if (a) {
          this.$store.commit('setEliminando', true)
          this.$store.dispatch('eliminarlineafactura', linea)
        }
      },
      guardardatosfactura () {
        if (this.lineas.length === 0) {
          this.$store.commit('actualizarerror', true)
          this.$store.commit('actualizarmessage_error', 'por favor ingrese productos')
        } else {
          this.$store.dispatch('actualizarnumerofactura', {factura: this.factura})
        }
      },
      guardarfactura () {
        this.$store.dispatch('guardarfactura', {factura: this.factura})
      },
      guardarcliente () {
        this.$store.dispatch('editarclientefactura', this.cliente)
      },
      resetbusqueda () {
        this.nombreproducto = ''
        this.$store.commit('actualizarproductos', [])
      },
      focusbusqueda () {
        let vm = this
        setTimeout(function () {
          vm.$refs.searchprodi.focus()
        }, 100)
      },
      actualizarbodega (event) {
        if (this.haslineas) {
          let a = confirm('al cambiar se eliminaran todos los productos de la factura')
          if (a) {
            if (this.haslineas) {
              this.lineas.forEach(dato => {
                this.$store.dispatch('eliminarlineafactura', dato)
                if (!this.haslineas) {
                  this.$store.dispatch('actualizarbodega', {factura: this.factura})
                } else {
                  this.factura.bodega = !event
                }
              }
              )
            }
          } else {
            this.factura.bodega = !event
          }
        } else {
          this.$store.dispatch('actualizarbodega', {factura: this.factura})
        }
      }
    },
    computed: {
      eliminando: function () {
        return this.$store.getters.getEliminando
      },
      usuario: function () {
        return localStorage.getItem('usuario')
      },
      productos: function () {
        return this.$store.getters.productos
      },
      grabando: function () {
        return this.$store.getters.getguardando
      },
      barra: {
        get: function () {
          return this.$store.getters.producto.barra
        },
        set: function (event) {
          this.$store.commit('actualizarbarra', event)
        }
      },
      tipo: function () {
        return this.$store.getters.gettipo
      },
      vender_bodega: function () {
        console.log(localStorage.getItem('puede_vender_bodega'))
        console.log(this.$store.getters.get_vender_bodega)
        if (this.$store.getters.get_vender_bodega) {
          return this.$store.getters.get_vender_bodega
        } else {
          return localStorage.getItem('puede_vender_bodega') === 'true'
        }
      },
      haslineas: function () {
        if (this.lineas.length > 0) {
          return true
        } else {
          return false
        }
      },
      hasfactura: function () {
        return this.$store.getters.hasfactura
      },
      factura: function () {
        return this.$store.getters.factura
      },
      lineas: function () {
        return this.$store.getters.lineasfactura
      },
      total: function () {
        let temptotal = 0
        this.lineas.map(dato => {
          temptotal += dato.cantidad * dato.precio
        })
        return (this.redondear(temptotal)).toFixed(2) || 0
      },
      cliente: function () {
        return this.$store.getters.cliente
      },
      producto: function () {
        return this.$store.getters.producto
      },
      fecha: function () {
        let fecha = new Date(this.$store.getters.factura.fecha)
        return fecha.toLocaleDateString('es-gt')
      },
      hora: function () {
        let fecha = new Date(this.$store.getters.factura.fecha)
        return fecha.toLocaleTimeString('es-gt')
      },
      listado: {
        get: function () {
          return this.$store.getters.listado || ''
        },
        set: function (dato) {
          this.$store.commit('updateselect', dato)
        }
      },
      dialog: {
        get: function () {
          return this.$store.getters.dialogo
        },
        set: function (dato) {
          this.$store.commit('actualizardialog', dato)
        }
      },
      precio: {
        get: function () {
          if (this.presentacion.presentacion === 'unidad') {
            return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100)) * this.presentacion.unidades
          }
          if (this.presentacion.presentacion !== 'unidad' && (this.listado.lista.nombre !== 'l6' || this.listado.lista.nombre !== 'l7')) {
            return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades)
          }
          return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades)
        }
      },
      presentaciones: function () {
        return this.$store.getters.presentaciones
      },
      presentacion: {
        get: function () {
          if (this.$store.getters.presentacion) {
            return this.$store.getters.presentacion
          } else {
            return ''
          }
        },
        set: function (dato) { this.$store.commit('actualizarpresentacion', dato) }
      },
      error: function () {
        return this.$store.getters.error_numero
      },
      success: function () {
        return this.$store.getters.success
      },
      cambio: function () {
        return (this.total - this.efectivo).toFixed(2)
      },
      message_error: function () {
        return this.$store.getters.message_error
      },
      message_success: function () {
        return this.$store.getters.message_success
      },
      numerosaletras: function () {
        return NumerosLetras.NumeroALetras(this.total, {
          plural: 'QUETZALES',
          singular: 'QUETZAL',
          centPlural: 'CENTAVOS',
          centSingular: 'CENTAVOS'
        })
      },
      validatefactura: function () {
        if (this.lineas.length === 30 && localStorage.getItem('usuario') !== '1' && localStorage.getItem('usuario') !== 'L2') {
          return true
        }
        return false
      }
    }
  }
</script>
<style>
   @media only screen and (min-device-width: 480px){
     .existencia {
       position: fixed;
       top: 13em;
     }
    .existencia{
       position: fixed;
       left: 10em;
       top: 6.1em;
     }
     .existencia__vencimiento {
       display: block;
       margin-top: 0.25rem;
     }
     .listadoproducto li {
       padding: 8px;
     }
   }
</style>



// WEBPACK FOOTER //
// Facturaadd.vue?0f3ec4b8